import {
  Required,
  IsString,
  IsNumber,
  DataValidator,
  transformKeys,
  ValidateNested,
} from "@/utils/type-vaildator";
import api from "./api";

interface SidebarProjectParams {
  name: string;
  folder_id: string | null;
  workspace_id: string;
}

interface SidebarProjectProps {
  name: string;
  folderId: string | null;
  workspaceId: string;
}

interface SidebarProjectResponse {
  project: {
    folder_id: string | null;
    id: string;
    name: string;
    sort_order: number;
    created_at: number;
    latest_video_image?: string;
  };
}

// 嵌套对象类
class Project {
  @IsString("Folder ID must be a string or null")
  folderId: string | null;

  @Required("ID cannot be empty")
  @IsString("ID must be a string")
  id: string;

  @Required("Name cannot be empty")
  @IsString("Name must be a string")
  name: string;

  @Required("Sort order cannot be empty")
  @IsNumber("Sort order must be a number")
  sortOrder: number;

  // @Required("Created at cannot be empty")
  // @IsNumber("Created at must be a number")
  createdAt: number;

  latestVideoImage?: string;
}

// 主数据类
export class SidebarProjectData {
  @Required("Project cannot be empty")
  @ValidateNested(Project)
  project: Project;
}

const transformAndValidateSidebarProject = (
  response: SidebarProjectResponse
): SidebarProjectData => {
  const transformedData = transformKeys(response);

  try {
    return DataValidator.validateOrThrow(transformedData, SidebarProjectData);
  } catch (error) {
    console.error("Sidebar project data validation failed:", error.message);
    throw error;
  }
};

// 新建项目
export const sidebarProject = async (props: SidebarProjectProps): Promise<SidebarProjectData> => {
  const params: SidebarProjectParams = {
    name: props.name,
    folder_id: props.folderId,
    workspace_id: props.workspaceId,
  };
  const response = await api.post<SidebarProjectResponse>("/sidebar/project", params);
  const validatedData = transformAndValidateSidebarProject(response.data);
  return validatedData;
};
